import { ApiProperty } from "@nestjs/swagger";
import { ForkLiftJobDto } from "../../fork-lift-jobs/dto/fork-lift-job.dto";
import { ForkLiftJobs } from "../../fork-lift-jobs/fork-lift-jobs.entity";
export class ForkLiftItemsDto {
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    pallet: number;
    @ApiProperty()
    currentPosition: number;
    @ApiProperty()
    targetPosition: number;
    @ApiProperty()
    realPosition: number;
    @ApiProperty()
    date: Date;
    @ApiProperty()
    createdUser: string;
    @ApiProperty()
    updatedUser: string;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    syncStatus?: boolean;
    @ApiProperty()
    versionFlag: number;
    @ApiProperty()
    forkLiftItemId: number;
    @ApiProperty()
    jobCartons?: number;
    @ApiProperty({ type: [ForkLiftJobs]})
    forkLiftJobInfo: ForkLiftJobs;
    @ApiProperty()
    issuedQuantity?: number;
    @ApiProperty()
    receivedQuantity?: number;
    @ApiProperty()
    stockId?: number;
    @ApiProperty()
    unitId?: number;
} 
